import {AppStore} from "../../desktop";
import {Folder} from "../../models/Folder";
import {FoldersActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";

export const actionFolderFetchAll = () => {
	AppStore.dispatch({type: FoldersActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionFolderFetchAllCompleted = (folders: Folder[]) => {
	AppStore.dispatch({type: FoldersActionTypes.FETCH_ALL_COMPLETED, payload: folders})
}

export const actionFolderFetch = (folder: Folder) => {
	AppStore.dispatch({type: FoldersActionTypes.FETCH_ONE_REQUEST, payload: folder})
}

export const actionFolderFetchCompleted = (folder: Folder) => {
	AppStore.dispatch({type: FoldersActionTypes.FETCH_ONE_COMPLETED, payload: folder})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: folder})
}

export const actionFolderSave = (folder: Folder) => {
	AppStore.dispatch({type: FoldersActionTypes.SAVE_REQUEST, payload: folder})
}

export const actionFolderSaveCompleted = (folder: Folder) => {
	AppStore.dispatch({type: FoldersActionTypes.SAVE_COMPLETED, payload: folder})
}

export const actionFolderDelete = (folder: Folder) => {
	AppStore.dispatch({type: FoldersActionTypes.DELETE_REQUEST, payload: folder})
}

export const actionFolderDeleteCompleted = (folder: Folder) => {
	AppStore.dispatch({type: FoldersActionTypes.DELETE_COMPLETED, payload: folder})
}

export const actionDeleteCategories = (folders: Folder[]) => {
	AppStore.dispatch({type: FoldersActionTypes.DELETE_MULTIPLE_REQUEST, payload: folders})
}

export const actionDeleteFoldersCompleted = (folders: Folder[]) => {
	AppStore.dispatch({type: FoldersActionTypes.DELETE_MULTIPLE_COMPLETED, payload: folders})
}

export const actionSaveExpandedNodes = (nodeIds: string[]) => {
	AppStore.dispatch({type: FoldersActionTypes.SAVE_EXPANDED_NODES, payload: nodeIds})
}
